import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, AuthCallback } from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import StudentDashboard from "@/pages/student/StudentDashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import SuperAdminDashboard from "@/pages/superadmin/SuperAdminDashboard";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import LegalInformationPage from "@/pages/LegalInformationPage";
import NewsPage from "@/pages/NewsPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import PublicDashboard from "@/pages/PublicDashboard";
import Tutorial from "@/pages/Tutorial";
import StageTwoDisbursementPortal from "@/pages/StageTwoDisbursementPortal";
import InterviewerDashboard from "@/pages/interviewer/InterviewerDashboard";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy-policy" element={<LegalInformationPage pageKey="privacy" />} />
      <Route path="/syarat-ketentuan" element={<LegalInformationPage pageKey="terms" />} />
      <Route path="/pedoman-program" element={<LegalInformationPage pageKey="guide" />} />
      <Route path="/berita" element={<NewsPage />} />
      <Route path="/berita/:slug" element={<NewsDetailPage />} />
      <Route path="/dashboard-publik" element={<PublicDashboard />} />
      <Route path="/tutorial" element={<Tutorial />} />
      <Route
        path="/portal-pencairan-tahap-ii"
        element={<StageTwoDisbursementPortal />}
      />
      <Route path="/dashboard" element={<ProtectedRoute roles={["student"]}><StudentDashboard /></ProtectedRoute>} />
      <Route
        path="/admin"
        element={(
          <ProtectedRoute roles={["admin", "admin_wilayah", "super_admin"]}>
            <AdminDashboard />
          </ProtectedRoute>
        )}
      />
      <Route path="/super-admin" element={<ProtectedRoute roles={["super_admin"]}><SuperAdminDashboard /></ProtectedRoute>} />
      <Route path="/interviewer" element={<ProtectedRoute roles={["interviewer"]}><InterviewerDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors closeButton />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
